import { render, staticRenderFns } from "./VersionModalReceiveLog.vue?vue&type=template&id=04837828&scoped=true"
import script from "./VersionModalReceiveLog.vue?vue&type=script&lang=js"
export * from "./VersionModalReceiveLog.vue?vue&type=script&lang=js"
import style0 from "./VersionModalReceiveLog.vue?vue&type=style&index=0&id=04837828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04837828",
  null
  
)

export default component.exports